<script>
import FormInput from '@vvg/forum/js/mixins/formInput'

export default {
	name: "Asset",
	mixins: [FormInput],
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		},
		'asset': {
			type: [Object, Array],
			required: false,
			default: null
		},

	},
	computed: {
		isMultiple() {
			return this.$attrs.multiple !== undefined;
		},
		currentFile() {
			return this.form[this.name] ?? null;
		},
		files() {
			let items = [];

			if (this.isMultiple) {
				let currentFiles = Array.isArray(this.currentFile) ? this.currentFile : [];
				let assets = Array.isArray(this.asset) ? this.asset : [];

				assets.forEach((assetItem) => {
					items.push({ file: null, asset: assetItem });
				});

				currentFiles.forEach((fileItem) => {
					if (fileItem && fileItem.id) {
						items.push({ file: null, asset: fileItem });
					} else {
						items.push({ file: fileItem, asset: null });
					}
				});
			} else {
				if (this.currentFile && this.currentFile.data) {
					items.push({ file: this.currentFile, asset: null });
				} else if (this.currentFile?.id) {
					items.push({ file: null, asset: this.currentFile });
				}
			}

			return items;
		},
		hasFile() {
			return this.files.length > 0;
		}
	},
	methods: {
		async changeModelValue(event) {
			let files = event.target.files;

			if (!files || files.length === 0) {
				this.form[this.name] = this.isMultiple ? [] : null;
				return;
			}

			if (this.isMultiple) {
				let converted = Array.isArray(this.currentFile) ? [...this.currentFile] : [];
				for (let index = 0; index < files.length; index++) {
					converted.push(await this.fileToBase64(files[index]));
				}
				this.form[this.name] = converted;
				this.$refs.fileInput.value = '';
				return;
			}

			this.form[this.name] = await this.fileToBase64(files[0]);
		},
		getPreviewUrl(item) {
			if (item.file && item.file.data) {
				return item.file.data;
			}
			return item.asset?.file_location ?? null;
		},
		isImage(item) {
			let mimeType = item.file?.type ?? item.asset?.mime_type ?? null;
			return mimeType && mimeType.startsWith('image/');
		},
		getDisplayName(item) {
			return item.file?.name ?? item.asset?.orig_name ?? '';
		},
		removeFile(index) {
			if (this.isMultiple) {
				let currentFiles = Array.isArray(this.currentFile) ? [...this.currentFile] : [];
				let assets = Array.isArray(this.asset) ? [...this.asset] : [];
				let assetsCount = assets.length;

				if (index < assetsCount) {
					let removedAsset = assets[index];
					this.$emit('remove-asset', removedAsset);
				} else {

					let fileIndex = index - assetsCount;
					currentFiles.splice(fileIndex, 1);
					this.form[this.name] = currentFiles;
				}
			} else {
				this.form[this.name] = null;
			}

			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = '';
			}
		},
		fileToBase64(file) {
			return new Promise((resolve, reject) => {
				let reader = new FileReader();
				reader.onload = () => {
					resolve({
						name: file.name,
						type: file.type,
						size: file.size,
						data: reader.result,
					});
				};
				reader.onerror = (error) => {
					reject(error);
				};
				reader.readAsDataURL(file);
			});
		}
	}
}
</script>

<template>
	<div class="form-group" :class="[groupClasses, { 'has-error': hasError }]">
		<label v-if="label" :for="renderedId">{{ label }}</label>

		<div v-show="hasFile" class="w-100 mb-3">
			<div v-for="(item, index) in files" :key="index" class="d-flex gap-3 mb-2 align-items-center">
				<div class="flex-grow-1" v-if="!isImage(item)">
                    <span v-if="item.file">
                        {{ getDisplayName(item) }}
                    </span>
					<a :href="getPreviewUrl(item)" v-else-if="item.asset?.id" target="_blank">
						 {{ getDisplayName(item) }}
					</a>
				</div>
				<div class="flex-grow-1" v-else>
					<img
						:src="getPreviewUrl(item)"
						:alt="getDisplayName(item)"
						:title="getDisplayName(item)"
						class="asset-preview"
					/>
				</div>
				<button class="btn btn-danger align-self-start" type="button" @click="removeFile(index)">
					<i class="fa fa-trash"></i>
				</button>
			</div>
		</div>

		<input
			v-if="isMultiple || !hasFile"
			v-bind="$attrs"
			ref="fileInput"
			type="file"
			:id="renderedId"
			:name="name"
			@change="changeModelValue"
			class="form-control"
			:class="{ 'is-invalid': hasError }"
		/>

		<small v-if="hasError" class="text-danger d-block mt-1">
			{{ form.errors[name] }}
		</small>
	</div>
</template>

<style scoped>

.asset-preview {
	max-width: 200px;
	max-height: 200px;
}
</style>